// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dispatched-tasks table td[data-v-76830925]:not(:last-child),\r\n.dispatched-tasks table td.mat-cell[data-v-76830925] {\r\n    border-right: solid 1px rgb(0, 0, 0, 0.12) !important;\n}\n.dispatched-tasks table td[data-v-76830925] {\r\n    border-bottom: solid 1px rgb(0, 0, 0, 0.12) !important;\n}\n.dispatched-tasks tbody[data-v-76830925]:hover {\r\n    background-color: #eee;\n}\r\n", ""]);
// Exports
module.exports = exports;
